import React, { Component } from 'react'
import './Style.scss'

import { LoginForm, ForgotForm } from './Component'
import { LoginWithPhone } from './LoginWithPhone'
import { Grid } from '@mui/material'
import Button from './../../Components/common/Button'
import { displayErrorMessages } from '../../Helpers'
import axios from "axios";
import { toast } from 'react-toastify';
export default class Login extends Component {
  constructor (props) {
    super(props)
    this.state = {
      view: 'login',
    }
  }
  // loginwithphone
      handlePhoneChange = (value) => {
      const isValid = this.validatePhone(value);
      this.setState({
        phone: value,
        isValid,
        isError: false,
      });
    };
  
    validatePhone = (phone) => {
      return /^\d{10,15}$/.test(phone);
    };
    
  validatePhone = (phone) => /^\d{10,15}$/.test(phone);
  validateOTP = (otp) => /^\d{4}$/.test(otp);
  
    handlePhoneChange = (value) => {
      const isPhoneValid = this.validatePhone(value);
      this.setState({
        phone: value,
        isPhoneValid,
        isOTPSent: false,
        failed: false,
        otp: '',
        isOTPValid: false,
        message: '',
        isError: false,
      });
    };
  
    handleOTPChange = (e) => {
      const otp = e.target.value;
      const isOTPValid = this.validateOTP(otp);
      this.setState({ otp, isOTPValid });
    };
  
    startResendCountdown = () => {
    this.setState({ resendTimer: 120, showResendButton: false });
  
    const interval = setInterval(() => {
      this.setState(prev => {
        if (prev.resendTimer <= 1) {
          clearInterval(this.state.timerInterval);
          return { resendTimer: 0, showResendButton: true, timerInterval: null };
        }
        return { resendTimer: prev.resendTimer - 1 };
      });
    }, 1000);
  
    this.setState({ timerInterval: interval });
  };
  
  handleSend = (e) => {
    e.preventDefault();
    const { phone } = this.state;
    this.setState({
      loading:true
    })
  
    axios
      .post(`/api/session/generateotp?phone=${phone}`)
      .then((res) => {
        const data = res.data;
  
        if (data.status === 'success') {
          this.setState({
            isOTPSent: true,
            otp: '',
            message: this.props.translate('otpSent') || 'OTP sent successfully!',
            isError: false,
            loading:false
          });
          toast.success("OTP sent successfully!");
          this.startResendCountdown(); 
        } else {
          this.setState({
            failed: true,
            isError: true,
            loading:false,
            message: this.props.translate(data.message) || data.message,
            loginErrorMessage: data.message,
          });
          toast.error(data.message || "Failed to send OTP");
        }
      })
      .catch((err) => {
        console.error('OTP API error:', err);
        this.setState({
          failed: true,
          isError: true,
          loading:false,
          message: this.props.translate('otpFailed') || 'Failed to send OTP',
          loginErrorMessage: 'otpFailed',
        });
        toast.error("Failed to send OTP");
      });
  };
  
  handleResend = () => {
    const { phone } = this.state;
    this.setState({
      loading:true
    })
    axios
      .post(`/api/session/generateotp?phone=${phone}`)
      .then((res) => {
        const data = res.data;
        if (data.status === 'success') {
          this.setState({
            message: 'OTP resent successfully!',
            otp: '',
            isOTPValid: false,
            loading:false
          });
          this.startResendCountdown(); // reset timer
          toast.success('OTP resent successfully!');
        } else {
           this.setState({
            loading:false
          });
          toast.error(data.message || 'Failed to resend OTP');
        }
      })
      .catch(() => {
          this.setState({
            loading:false
          });
        toast.error('Failed to resend OTP');
      });
  };
    errorCallBack = (data) => {
    this.setState({
      failed: true,
      otp: "",
      loading: false,
      loginErrorMessage: data?.message?displayErrorMessages(data?.message):"Something went wrong",
    });
  };
  switchView = view => {
    this.setState({ view })
  }
  render () {
    const { view } = this.state
    const bgImage = this.props.whiteLabling?.logInPageImage || '/assets/images/default-login-bg.png'
    return (
      <div
        className='loginWrapper'
     style={{
   backgroundImage: `url("${bgImage}")`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    width: '100vw',
    height: '100vh',
  }}
      >
   
        <div className='loginWrapperInner'>
          <div className='loginForm'>

                  <Grid container className="breadcrumb-row">
                      <Grid item xs={4} sm={12} style={{ display: "flex" }}>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => this.switchView("login")}
                          style={{
                            width: "100%",
                            borderTopRightRadius: " 15px",
                            borderTopLeftRadius: "15px",
                            marginLeft: "5px",
                            backgroundColor:
                              view === "login"
                                ? "#00C179"
                                : "#ffff",
                            color:
                              view === "login"
                                ? "#ffff"
                                : "#00C179",
                          }}
                        >
                          {this.props.translate("login with Email")}
                        </Button>
        
                        <Button
                          variant="contained"
                          disabled={false}
                          onClick={() => this.switchView("loginWithPhone")}
                          style={{
                            width: "100%",
                            borderTopRightRadius: " 15px",
                            borderTopLeftRadius: "15px",
                            marginLeft: "5px",
                            backgroundColor:
                              view === "loginWithPhone" ? "#00C179" : "#ffff",
                            color:
                              view === "loginWithPhone" ? "#ffff" : "#00C179",
                          }}
                        >
                          {" "}
                          {this.props.translate("login With Phone")}
                        </Button>
                      </Grid>
                    </Grid>
          {view === 'login' ? (
            <LoginForm {...this.props} switchView={this.switchView} />
          ) : null}
          {view === 'loginWithPhone' ? (
            <LoginWithPhone
             {...this.props}
             {...this.state}
             switchView={this.switchView}
             handlePhoneChange={this.handlePhoneChange}
             handleOTPChange={this.handleOTPChange}
             handleResend={this.handleResend}
             handleSend={this.handleSend}
             />
          ) : null}
          {view === 'forgot' ? (
            <ForgotForm {...this.props} switchView={this.switchView} />
          ) : null}
          </div>

        </div>
        <div
          className='white-label-bg'
          style={{ backgroundImage: 'url(/assets/images/login_wallpaper.png)' }}
        ></div>
      </div>
    )
  }
}
